import React from 'react'
import styled from 'styled-components'
import Link from 'next/link'

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-bottom: 15px;
  margin-top: 10px;
  font-size: 10pt;
`

const StyledUl = styled.ul`
  width: 100%;
  padding: 0;
`

const StyledA = styled.a`
  color: ${props => props.theme.colors.green1};
  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
    cursor: pointer;
  }
`

class LinkBox extends React.Component {
  getLinks = links => {
    return links
      ? links.map(link => (
          <li key={link.data.label}>
            {link.type === 'external' ? (
              <StyledA href={link.data.url} target="_blank">
                {link.data.label}
              </StyledA>
            ) : (
              <Link
                as={`/explore/element/${link.data.id}`}
                href={`/explore/element?elementId=${link.data.id}`}
              >
                <StyledA>{link.data.label}</StyledA>
              </Link>
            )}
          </li>
        ))
      : null
  }
  render() {
    return (
      <StyledDiv>
        <StyledUl>
          <span>
            <b>{this.props.title}</b>
          </span>
          {this.getLinks(this.props.links)}
        </StyledUl>
        {/*props.relatedLinks*/}
      </StyledDiv>
    )
  }
}

export default LinkBox
